import ElementUI from 'element-ui'

export default {
  watch: function (axios) {
    // Add a request interceptor
    axios.interceptors.request.use(function (config) {
      return config
    }, function (error) {
      ElementUI.Notification.warning({
        title: 'Erreur de communication',
        message: 'Une erreur inconnue est survenue.',
        duration: 0
      })
      return Promise.reject(error)
    })

    // Add a response interceptor
    axios.interceptors.response.use(function (response) {
      return response
    }, function (error) {
      if (error.response) {
        if (error.response.config.url !== 'static/git_version' && error.response.status !== 401) {
          ElementUI.Notification.warning({
            title: 'Erreur de communication',
            message: 'Une erreur est survenue lors de la demande "' + error.response.config.method.toUpperCase() + ' ' + error.response.config.url + '" : ' + error.response.status + ' (' + error.response.statusText + ').',
            duration: 0
          })
        }
      } else if (error.request) {
        ElementUI.Notification.warning({
          title: 'Erreur de communication',
          message: 'Une erreur est survenue.',
          duration: 0
        })
      } else {
        ElementUI.Notification.warning({
          title: 'Erreur de communication',
          message: 'Une erreur est survenue : ' + error.message + '.',
          duration: 0
        })
      }

      return Promise.reject(error)
    })
  }
}



// WEBPACK FOOTER //
// ./libs/@db2b/keystone/services/axios-error-notifier.js